import { render, staticRenderFns } from "./settingRedActNew.vue?vue&type=template&id=db994f1c&scoped=true&"
import script from "./settingRedActNew.vue?vue&type=script&lang=js&"
export * from "./settingRedActNew.vue?vue&type=script&lang=js&"
import style0 from "./settingRedActNew.vue?vue&type=style&index=0&id=db994f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db994f1c",
  null
  
)

component.options.__file = "settingRedActNew.vue"
export default component.exports